import { useEffect, useState } from 'react';
import { getOrderProblemsApi } from '@/core/api/generatedApiClient';
import { handleApiError } from '@/core/utils/handleApiError';

export const ORDER_PROBLEMS_CHANGED_EVENT = 'vox:order-problems-changed';

/** Получает количество активных проблем доступного раздела заказов */
export const useOrderProblemCount = (enabled: boolean): number => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!enabled) return;

        let active = true;
        let pending = false;
        setCount(0);

        /** Обновляет количество проблем */
        const refresh = async () => {
            if (pending) return;

            pending = true;

            try {
                const response = await getOrderProblemsApi().getActiveOrderProblemCount();

                if (active) setCount(response.data);
            } catch (error: unknown) {
                if (active) handleApiError(error);
            } finally {
                pending = false;
            }
        };

        void refresh();
        const timer = window.setInterval(() => void refresh(), 30_000);
        window.addEventListener(ORDER_PROBLEMS_CHANGED_EVENT, refresh);

        return () => {
            active = false;
            window.clearInterval(timer);
            window.removeEventListener(ORDER_PROBLEMS_CHANGED_EVENT, refresh);
        };
    }, [enabled]);

    return enabled
        ? count
        : 0;
};
